import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Home from "./components/Home";
import PdfUnlocker from "./components/PdfUnlocker";

// Component to track page views
const PageTracker = () => {
  const location = useLocation();
  
  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', 'G-0GVD1HL4DJ', {
        page_path: location.pathname + location.search
      });
    }
  }, [location]);

  return null;
};

function App() {
  return (
    <Router>
      <PageTracker />
      <div>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/pdf-unlocker" element={<PdfUnlocker />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
